import "core-js/modules/es.array.push.js";
import axios from 'axios';
import Bus from '@/assets/js/bus.js';
import draggable from 'vuedraggable';
import Tool, { handleLocalStorage, returnSourceType } from '@/assets/js/utils.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { mapState } from 'vuex';
import { controlDeviceBehavior, changeBehaviorStatus } from '@/assets/js/attendUser.js';
import cookie from 'js-cookie';
export default {
  computed: {
    ...mapState({
      State: state => state,
      nickNameMap: state => state.nickNameMap,
      loginInfo: state => state.loginInfo
    })
  },
  components: {
    draggable
  },
  data() {
    return {
      mic: true,
      speaker: true,
      partyInfo: {},
      talentSearch: '',
      talentList: [],
      allTalentList: [],
      // 用来在没有搜索时恢复全部显示
      talentTimer: null,
      stationSearch: '',
      stationList: [],
      allStationList: [],
      // 用来在没有搜索时恢复全部显示
      stationTimer: null,
      sessionList: [],
      rtc: null,
      rtcLoaded: false,
      channels: {},
      deviceType: {},
      devicesInfo: {},
      selectSessionInfo: {},
      noSessionSelectTalents: [],
      noSessionSelectStations: [],
      activeSpeakerInfo: {},
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      controlActiveTime: 0,
      selectStationInfo: [],
      allRtilCode: [],
      hasPushTalkingInfo: {} // 用来记录当前正在 pushtalk 的 rtilCode
    };
  },

  async created() {
    window.addEventListener('keydown', this.listenEvent);
    this.rtc = new AgoraClient(this.AgoraCallBack);
    this.devicesInfo = await this.rtc.getDevice();
    this.getPartyInfo();
    Bus.$on('intercomPro', val => {
      var _this$partyInfo$manag;
      const {
        status,
        subModule,
        rtilCode,
        talk,
        intercomSessionId,
        sessionId,
        sessionName
      } = val;
      switch (subModule) {
        case 'intercomProSessionActive':
        case 'intercomProSessionInactive':
          if (rtilCode == this.partyInfo.rtilCode) return;
          this.asyncSessionActiveStatus(intercomSessionId, status);
          break;
        case 'intercomProAddStationsTalents':
          if (rtilCode == this.partyInfo.rtilCode) return;
          this.asyncSessionStationsTalents(val, 'add');
          break;
        case 'intercomProDelStationsTalents':
          if (rtilCode == this.partyInfo.rtilCode) return;
          this.asyncSessionStationsTalents(val, 'delete');
          break;
        case 'intercomProCreateSession':
          this.updateSessionList(val);
          break;
        case 'intercomProDelSession':
          if (rtilCode == this.partyInfo.rtilCode) return;
          this.sessionList = this.sessionList.filter(item => item.intercomSessionId != sessionId);
          break;
        case 'intercomProUpdateSession':
          if (rtilCode == this.partyInfo.rtilCode) return;
          this.sessionList.forEach(item => {
            if (item.intercomSessionId == sessionId) {
              item.sessionName = sessionName;
            }
          });
          break;
        case 'intercomProPushToTalk':
        case 'intercomProPushToHost':
          if (rtilCode == this.partyInfo.rtilCode || (_this$partyInfo$manag = this.partyInfo.managerRtils) !== null && _this$partyInfo$manag !== void 0 && _this$partyInfo$manag.includes(rtilCode)) return;
          this.$set(this.hasPushTalkingInfo, rtilCode, talk);
          this.dealStationPushTalk(rtilCode, talk, intercomSessionId);
          talk ? this.$message.success(this.$t('intercom.webStationHasTalk', {
            staionName: this.nickNameMap[rtilCode],
            sessionName
          })) : this.$message.success(this.$t('intercom.webStationEndTalk', {
            staionName: this.nickNameMap[rtilCode],
            sessionName
          }));
          break;
      }
    });
    Bus.$on('setBehaviors', val => {
      const behaviors = val.behaviors;
      behaviors.forEach(item => {
        const {
          key,
          mark
        } = item;
        if (key === 'addIntercomProDeviceRtilCode') {
          this.getDeviceDatailByRtilCode({
            id: mark,
            channel: this.partyInfo.joinCode
          });
        }
      });
    });
  },
  methods: {
    getAllStation() {
      this.axios.get(`/partyline-backend/behavior/noLogin/getKeyList?partyCode=${this.partyInfo.joinCode}&key=addIntercomProDeviceRtilCode`).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const info = JSON.parse(item.value);
            const rtilCode = info.rtilCode;
            const deviceType = returnSourceType(info, info.sessionType);
            this.$set(this.nickNameMap, rtilCode, info.nickName);
            this.$set(this.deviceType, rtilCode, deviceType);
            if (deviceType === 'T' || deviceType === 'Talent') {
              const isHaveThis = this.talentList.find(talentItem => talentItem.rtilCode == rtilCode);
              if (!isHaveThis) {
                this.talentList.push({
                  ...info,
                  online: false
                });
                this.allTalentList.push({
                  ...info,
                  online: false
                });
              }
            } else {
              info.online = false;
              info.email = '';
              info.emailList = [];
              const isHaveThis = this.State.stationList.find(stationItem => stationItem.rtilCode == rtilCode);
              if (!isHaveThis) {
                this.stationList.push(info);
                this.allStationList.push(info);
                this.State.stationList.push(info);
              }
            }
          });
        }
      });
    },
    asyncSessionActiveStatus(intercomSessionId, status) {
      status ? this.$message.success(this.$t('intercom.activeSession')) : this.$message.success(this.$t('intercom.deactiveSession'));
      this.sessionList.forEach(item => {
        if (item.intercomSessionId == intercomSessionId) {
          item.status = status;
        }
      });
    },
    asyncSessionStationsTalents(val, type) {
      var _dealObject$;
      const {
        intercomSessionId,
        sessionTalentsList,
        sessionStationsList
      } = val;
      // 如果 sessionTalentsList 有则是处理 talent 的
      const isAdd = type === 'add';
      const dealKey = sessionTalentsList ? 'sessionTalentsList' : 'sessionStationsList';
      const dealObject = sessionTalentsList || sessionStationsList;
      const rtilCode = dealObject === null || dealObject === void 0 ? void 0 : (_dealObject$ = dealObject[0]) === null || _dealObject$ === void 0 ? void 0 : _dealObject$.rtilCode;
      if (!rtilCode) return;
      this.sessionList.forEach(item => {
        if (item.intercomSessionId == intercomSessionId) {
          if (isAdd) {
            if (dealKey === 'sessionTalentsList') {
              item.talentsRtilCodes.push(rtilCode);
            } else {
              item.stationsRtilCodes.push(rtilCode);
            }
            item[dealKey].push(dealObject[0]);
          } else {
            item[dealKey] = item[dealKey].filter(item1 => item1.rtilCode != dealObject[0].rtilCode);
            if (dealKey === 'sessionTalentsList') {
              item.talentsRtilCodes = item.talentsRtilCodes.filter(rtilCodes => rtilCodes != rtilCode);
            } else {
              item.stationsRtilCodes = item.stationsRtilCodes.filter(rtilCodes => rtilCodes != rtilCode);
            }
          }
        }
      });
    },
    updateSessionList(val) {
      const dataInfo = {
        intercomSessionId: val.sessionId,
        partyCode: this.partyInfo.joinCode,
        rtilCode: this.partyInfo.rtilCode,
        sessionTalentsList: val.sessionTalentsList || [],
        sessionStationsList: val.sessionStationsList || [],
        talentsRtilCodes: val.sessionTalentsList.map(item => item.rtilCode) || [],
        stationsRtilCodes: val.sessionStationsList.map(item => item.rtilCode) || [],
        status: val.status || 0,
        sessionName: val.sessionName,
        showRenameInput: false,
        nameInputVal: '',
        sessionSpeaker: false,
        sessionTalk: false,
        pushToTalk: false
      };
      this.sessionList.push(dataInfo);
    },
    dealStationPushTalk(rtilCode, talk, intercomSessionId) {
      var _this$channels$rtilCo;
      const audioTrack = (_this$channels$rtilCo = this.channels[rtilCode]) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.audioTrack;
      const sessionInfo = this.sessionList.find(item => item.intercomSessionId == intercomSessionId);
      if (!audioTrack || !this.speaker || (sessionInfo === null || sessionInfo === void 0 ? void 0 : sessionInfo.sessionSpeaker) == false) return;
      if (talk) {
        audioTrack.play(audioTrack, '', {
          type: 'audio'
        });
      } else {
        audioTrack.stop();
      }
    },
    listenEvent(event) {
      if (!this.sessionList.length) return;
      const key = event.key;
      switch (key) {
        case 'ArrowUp':
          // 首先判断是否有选中的 session
          if (this.selectSessionInfo.intercomSessionId) {
            const index = this.sessionList.findIndex(item => item.intercomSessionId == this.selectSessionInfo.intercomSessionId);
            if (index > 0) {
              this.selectSessionInfo = this.sessionList[index - 1];
            } else {
              this.selectSessionInfo = this.sessionList[this.sessionList.length - 1];
            }
          } else {
            this.selectSessionInfo = this.sessionList[this.sessionList.length - 1];
          }
          this.selectStationInfo = [];
          this.noSessionSelectTalents = [];
          this.noSessionSelectStations = [];
          break;
        case 'ArrowDown':
          if (this.selectSessionInfo.intercomSessionId) {
            const index = this.sessionList.findIndex(item => item.intercomSessionId == this.selectSessionInfo.intercomSessionId);
            if (index < this.sessionList.length - 1) {
              this.selectSessionInfo = this.sessionList[index + 1];
            } else {
              this.selectSessionInfo = this.sessionList[0];
            }
          } else {
            this.selectSessionInfo = this.sessionList[0];
          }
          this.selectStationInfo = [];
          this.noSessionSelectTalents = [];
          this.noSessionSelectStations = [];
          break;
      }
    },
    async checkEnv(partyCode) {
      if (!partyCode) return;
      const params = {
        partyCode,
        clientType: 0,
        memberId: this.loginInfo.id
      };
      this.axios.get('/partyline-backend/party/noLogin/checkV2', {
        params
      }).then(res => {
        const result = res.data.result;
        result.updateEnv = true;
        const cookieList = cookie.get();
        Object.keys(cookieList).forEach(key => {
          if (result.tagKey == key && result.tagValue == cookieList[key]) {
            result.updateEnv = false;
          }
        });
        result.tagList && result.tagList.forEach(v => {
          if (v.tagKey != result.tagKey || v.tagValue != result.tagValue) {
            Tool.setTagCookie(v.tagKey, v.tagValue, -1);
          }
        });
        Tool.setTagCookie(result.tagKey, result.tagValue);
        // 更新环境
        if (result.updateEnv) {
          window.location.reload();
        }
      });
    },
    getPartyInfo() {
      axios.get('/partyline-backend/intercomPro/get').then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          Bus.$emit('changePartyAddress', {
            currentId: result.partyCode,
            lastId: result.id,
            init: 'initAside',
            title: result.title,
            id: result.id,
            createTime: result.createTime
          });
          Bus.$emit('updateInitStatus', {
            hasCopy: false
          });
          await this.checkEnv(result.partyCode);
          this.joinParty(result.partyCode);
        }
      });
    },
    joinParty(partyCode) {
      const joinId = this.State.loginInfo.id;
      const params = {
        memberId: joinId || 'PL_' + new Date().getTime(),
        partyCode: partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['speaker', 'nickName', 'mic']
      };
      axios.post('/partyline-backend/party/noLogin/join', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const {
            mic,
            speaker,
            nickName
          } = result.behavior;
          this.partyInfo = result;
          this.State.partyJoinInfo = result;
          this.mic = mic !== 'false';
          this.speaker = speaker !== 'false';
          this.$set(this.nickNameMap, result.rtilCode, nickName);
          this.getBindStation();
          this.getAllStation();
          this.getAllSession();
          this.createWebsocket(partyCode);
          this.joinChannel(result);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    createWebsocket(partyCode) {
      if (!this.State.pageSerBusRequestWs[partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode
        });
      }
    },
    async joinChannel(result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        joinCode
      } = result;
      const params = {
        appId,
        channel: joinCode,
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        video: false,
        audio: true,
        subscribeRemote: false,
        // 默认不订阅
        microphoneId: this.devicesInfo.microphoneId
      };
      const uid = await this.rtc.join(params);
      if (uid) {
        this.rtcLoaded = true;
      }
    },
    AgoraCallBack({
      action,
      payload
    }) {
      const {
        id,
        mediaType
      } = payload;
      switch (action) {
        case 'user-joined':
          const currentInfo = this.stationList.find(item => item.rtilCode == id);
          if (!currentInfo || currentInfo && !currentInfo.online) this.getDeviceDatailByRtilCode(payload);
          break;
        case 'user-published':
          if (mediaType === 'audio') {
            this.rtc.subscribe(id, 'audio');
          }
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'user-left':
          this.leave(id);
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
      }
    },
    getDeviceDatailByRtilCode(payload) {
      const {
        id,
        channel
      } = payload;
      if (!id || !channel) return;
      const params = {
        rtilCode: id,
        keys: ['nickName'],
        partyCode: this.partyInfo.joinCode
      };
      axios.post('/partyline-backend/receiver/noLogin/queryDeviceDetail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          if (!result) return;
          const rtilCode = result.rtilCode;
          const deviceType = returnSourceType(result, result.sessionType);
          result.email = '';
          result.emailList = [];
          this.$set(this.nickNameMap, rtilCode, result.nickName);
          this.$set(this.deviceType, rtilCode, deviceType);
          switch (deviceType) {
            case 'App':
            case 'T':
            case 'Talent':
              const isHaveAddT = this.talentList.find(item => item.rtilCode == id);
              if (isHaveAddT) {
                isHaveAddT.online = true;
                return;
              }
              this.talentList.push({
                ...result,
                online: true
              });
              this.allTalentList.push(result);
              break;
            case 'R':
              const isHaveAddR = this.State.stationList.find(item => {
                return item.rtilCode == Number(id);
              });
              // 防止重复添加
              if (!isHaveAddR) {
                this.stationList.push(result);
                this.allStationList.push(result);
                this.State.stationList.push(result);
              }
              break;
          }
          this.allRtilCode.push(result);
          this.stationList.forEach(item => {
            if (item.rtilCode == id) {
              item.online = true;
            }
          });
          this.getBindStation();
        }
      });
    },
    subscribeTrack(payload) {
      const {
        id,
        videoTrack,
        audioTrack
      } = payload;
      const obj = {
        id,
        videoTrack,
        audioTrack
      };
      this.$set(this.channels, id, obj);
    },
    footCallback(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'controlAudio':
          this.mic = val;
          this.rtc.setEnabled(val, 'audio');
          const partyInfo = this.partyInfo;
          controlDeviceBehavior({
            senderRtilCode: partyInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: partyInfo.joinCode,
            toRtilCode: partyInfo.rtilCode,
            origin: 'intercom',
            notChangeStatus: true
          });
          break;
        case 'controlSpeaker':
          this.speaker = val;
          this.State.speaker = val;
          changeBehaviorStatus({
            key: 'speaker',
            rtilCode: this.partyInfo.rtilCode,
            realPartyCode: this.partyInfo.joinCode,
            value: val
          });
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'controlTalkToAllTalents':
          // 需要添加按钮互斥
          let hasTalkTalentSession = false;
          this.sessionList.forEach(item => {
            if (item.sessionTalk || item.pushToTalk) {
              hasTalkTalentSession = true;
            }
          });
          if (hasTalkTalentSession) {
            this.$message.warning(this.$t('intercom.cannotTalkAllTalent'));
            return;
          }
          const isQuicklyOperation = this.isQuickluOperation();
          if (isQuicklyOperation) return;
          this.State.intercomTalkToAllTalents = !this.State.intercomTalkToAllTalents;
          this.sendTalkToAllTalents(this.State.intercomTalkToAllTalents);
          break;
        case 'changeNickName':
          this.$set(this.nickNameMap, this.partyInfo.rtilCode, val);
          break;
      }
    },
    switchDevice(info) {
      const {
        type,
        deviceId
      } = info;
      if (type === 'speaker') {
        handleLocalStorage('set', 'speakerId', deviceId);
      } else {
        this.rtc.setDevice(deviceId, type, result => {
          if (result === 'success') {
            this.$message.success(this.$t('common.switchMicSuccess'));
          } else {
            this.$message.warning(this.$t('common.switchMicFailed'));
          }
        });
      }
    },
    async getBindStation() {
      await this.axios.post('/partyline-backend/intercomPro/queryBindStation', {
        partyCode: this.partyInfo.joinCode
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          // 需要过滤返回的数据是否还在会议中
          const result = res.data.result;
          result.forEach(item => {
            this.$set(this.State.bindStationInfo, item.rtilCode, item);
            this.stationList.forEach(stationItem => {
              if (stationItem.rtilCode == item.rtilCode) {
                stationItem.email = item.email;
                stationItem.userId = item.userId;
              }
            });
          });
        }
      });
    },
    sendPushTalk(item, val) {
      const params = {
        timestamp: new Date().getTime(),
        partyCode: this.partyInfo.joinCode,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: item.talentsRtilCodes,
        stationsRtilCodes: item.stationsRtilCodes,
        intercomSessionId: item.intercomSessionId
      };
      const url = val ? '/intercomPro/enablePushTalk' : '/intercomPro/disablePushTalk';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.savePushTalkBehavior(item, val);
        } else {
          item.pushToTalk = !val;
          this.State.intercomPushTalk = !val;
        }
      });
    },
    savePushTalkBehavior(item, val) {
      if (!this.partyInfo.joinCode) return;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'pushToTalk',
          subKey: item.intercomSessionId,
          mark: this.partyInfo.rtilCode,
          value: val,
          annotation: this.partyInfo.joinCode,
          talentsRtilCodes: item.talentsRtilCodes,
          stationsRtilCodes: item.stationsRtilCodes,
          timestamp: new Date().getTime()
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {});
    },
    sendTalkToAllTalents(val) {
      const params = {
        rtilCode: this.partyInfo.rtilCode,
        timestamp: new Date().getTime(),
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        talentsRtilCodes: this.talentList.map(item => item.rtilCode) || []
      };
      const url = val ? '/intercomPro/enableTalkALL' : '/intercomPro/disableTalkALl';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {
        if (res.data.errorCode != '0x0') {
          this.State.intercomTalkToAllTalents = !this.State.intercomTalkToAllTalents;
        }
        this.saveTalkToAllTalentsBehavior(val);
      });
    },
    saveTalkToAllTalentsBehavior(val) {
      if (!this.partyInfo.joinCode) return;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'talkToAllTalent',
          subKey: 'talkToAllTalent',
          mark: this.partyInfo.rtilCode,
          value: val,
          annotation: this.partyInfo.joinCode,
          talentsRtilCodes: this.talentList.map(item => item.rtilCode) || [],
          timestamp: new Date().getTime()
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {});
    },
    saveConnectRtilCode(item, type) {
      if (type === 'talent') {
        if (this.State.talentConnectRtilCode && item.rtilCode == this.State.talentConnectRtilCode) {
          this.State.talentConnectRtilCode = '';
          this.$set(this.borderColor, item.rtilCode, '');
        } else {
          this.State.talentConnectRtilCode = item.rtilCode;
          this.$set(this.borderColor, item.rtilCode, 'whiteColor');
        }
      } else {
        if (this.State.stationConnectRtilCode && item.rtilCode == this.State.stationConnectRtilCode) {
          this.State.stationConnectRtilCode = '';
          this.$set(this.borderColor, item.rtilCode, '');
        } else {
          this.State.stationConnectRtilCode = item.rtilCode;
          this.$set(this.borderColor, item.rtilCode, 'whiteColor');
        }
      }
    },
    createSession() {
      if (!this.partyInfo.joinCode || !this.partyInfo.rtilCode) return;
      this.createMultiSession();
    },
    createMultiSession() {
      const paramsArray = [];
      this.noSessionSelectStations.forEach((item, index) => {
        const obj = {};
        const number = this.sessionList.length < 9 ? '0' + (this.sessionList.length + 1 + index) : this.sessionList.length + 1 + index;
        obj.partyCode = this.partyInfo.joinCode;
        obj.rtilCode = this.partyInfo.rtilCode;
        obj.sessionName = `session_${number}`;
        obj.sessionStationsList = [item];
        obj.sessionTalentsList = this.noSessionSelectTalents;
        paramsArray.push(obj);
      });
      this.axios.post('/partyline-backend/intercomPro/batch/createSession', paramsArray).then(res => {
        if (res.data.errorCode === '0x0') {
          // const result = res.data.result
          // result.forEach(info => {
          //   const data = {
          //     intercomSessionId: info.sessionId,
          //     partyCode: this.partyInfo.joinCode,
          //     rtilCode: this.partyInfo.rtilCode,
          //     sessionTalentsList: info.sessionTalentsList || [],
          //     sessionStationsList: info.sessionStationsList || [],
          //     talentsRtilCodes: info.sessionTalentsList.map(item => item.rtilCode) || [],
          //     stationsRtilCodes: info.sessionStationsList.map(item => item.rtilCode) || [],
          //     status: info.status || 0,
          //     sessionName: info.sessionName,
          //     showRenameInput: false,
          //     nameInputVal: '',
          //     sessionSpeaker: false,
          //     sessionTalk: false,
          //     pushToTalk: false
          //   }
          //   this.sessionList.push(data)
          // })
          this.clearNoSessionInfo();
        }
      });
    },
    getAllSession() {
      const params = {
        rtilCode: this.partyInfo.rtilCode,
        partyCode: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/intercomPro/querySessionList', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            item.sessionTalk = item.sessionTalk === 'true';
            item.pushToTalk = item.pushToTalk === 'true';
            item.showRenameInput = false;
            item.sessionSpeaker = item.sessionSpeaker === 'true';
            item.nameInputVal = '';
            item.talentsRtilCodes = item.sessionTalentsList.map(info => {
              return info.rtilCode;
            });
            item.stationsRtilCodes = item.sessionStationsList.map(info => {
              return info.rtilCode;
            });
          });
          this.sessionList = result;
          this.getPushTalkTalkAll();
        }
      });
    },
    getPushTalkTalkAll() {
      const params = {
        annotation: this.partyInfo.joinCode,
        keys: ['pushToTalk', 'talkToAllTalent'],
        subKeys: ['pushToTalk', 'talkToAllTalent'],
        marks: [this.partyInfo.rtilCode]
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const localInfo = result[this.partyInfo.rtilCode];
          if (localInfo) {
            Object.keys(localInfo).forEach(key => {
              const itemInfo = localInfo[key];
              if (key === 'pushToTalk') {
                this.State.pushTalk = itemInfo.pushTalk === 'true';
              } else {
                this.State.intercomTalkToAllTalents = (itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.talkToAllTalent) === 'true';
              }
            });
          }
        }
      });
    },
    changeSessionList(val) {
      const currentMoveInfo = val.moved;
      const oldIndex = currentMoveInfo.oldIndex;
      const newIndex = currentMoveInfo.newIndex;
      const {
        sessionId,
        position
      } = this.caculateDragResult(oldIndex, newIndex);
      const params = {
        sessionId: currentMoveInfo.element.intercomSessionId,
        partyCode: this.partyInfo.joinCode,
        rank: {
          sessionId,
          position
        }
      };
      this.axios.post('/partyline-backend//intercomPro/updatePosition', params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    caculateDragResult(oldIndex, newIndex) {
      let sessionId = '';
      let position = '';
      if (oldIndex < newIndex) {
        sessionId = this.sessionList[newIndex + 1] ? this.sessionList[newIndex - 1].intercomSessionId : this.sessionList[this.sessionList.length - 2].intercomSessionId;
        position = 'AFTER';
      } else {
        sessionId = this.sessionList[newIndex - 1] ? sessionId = this.sessionList[newIndex + 1].intercomSessionId : this.sessionList[1].intercomSessionId;
        position = 'BEFORE';
      }
      return {
        sessionId,
        position
      };
    },
    saveSelectSessionInfo(item) {
      this.clearNoSessionInfo();
      if (this.selectSessionInfo.intercomSessionId === item.intercomSessionId) {
        this.selectSessionInfo = {};
      } else {
        this.selectSessionInfo = item;
      }
    },
    showRenameInput(item) {
      item.showRenameInput = true;
      this.$nextTick(() => {
        const ref = this.$refs[item.intercomSessionId + '_input'];
        item.nameInputVal = item.sessionName;
        ref[0].$refs.input.focus();
        ref[0].$refs.input.select();
      });
    },
    saveSessionName(sessionName, item) {
      if (!sessionName) {
        this.$message.warning(this.$t('intercom.sessionNameEmpty'));
        return;
      }
      const params = {
        sessionId: item.intercomSessionId,
        sessionName,
        partyCode: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/intercomPro/updateSession', params).then(res => {
        if (res.data.errorCode === '0x0') {
          item.showRenameInput = false;
          item.sessionName = sessionName;
        }
      });
    },
    isQuickluOperation() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastOperationTime < 500) {
        return true;
      } else {
        this.lastOperationTime = currentTime;
        return false;
      }
    },
    controlActive(item) {
      const currentTime = new Date().getTime();
      if (currentTime - this.controlActiveTime < 1000) return;
      this.controlActiveTime = currentTime;
      this.selectSessionInfo = item;
      this.selectStationInfo = [];
      let activeSessionId = '';
      const haveActive = this.sessionList.filter(info => {
        if (info.status) activeSessionId = info.intercomSessionId;
        return info.status;
      });
      if (haveActive.length && item.intercomSessionId !== activeSessionId) {
        this.$message.warning(this.$t('intercom.onlyOneActive'));
        return;
      }
      if (!item.status && (!item.talentsRtilCodes.length || !item.stationsRtilCodes.length)) {
        this.$message.warning(this.$t('intercom.enableActiveFailed'));
        return;
      }
      const url = item.status ? '/partyline-backend/intercomPro/sessionInactive' : '/partyline-backend/intercomPro/sessionActive';
      item.status = item.status ? 0 : 1;
      this.selectSessionInfo.status = item.status;
      const params = {
        status: item.status,
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: item.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: item.sessionTalentsList.map(info => info.rtilCode),
        stationsRtilCodes: item.sessionStationsList.map(info => info.rtilCode)
      };
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode !== '0x0') {
          item.status = params.status ? 0 : 1;
          this.selectSessionInfo.status = params.status ? 0 : 1;
        } else {
          if (item.sessionSpeaker && params.status) return; // speaker 已经打开时再去 active 就不要再去调用打开 sepaker 接口
          if (!item.sessionSpeaker && !params.status) return; // speaker 已经关闭时再去 inactive 就不需要调用关闭 speaker 接口
          this.controlSessionSpeaker(item, params.status);
        }
      }).catch(() => {
        item.status = params.status ? 0 : 1;
        this.selectSessionInfo.status = params.status ? 0 : 1;
      });
    },
    controlSessionTalkToTalent(item) {
      if (item.pushToTalk) {
        this.$message.warning(this.$t('intercom.cannotTalkToTalent'));
        return;
      }
      if (this.State.intercomTalkToAllTalents) {
        this.$message.warning(this.$t('intercom.cannotTalkToTalentByTalkALL'));
        return;
      }
      const isQuicklyOperation = this.isQuickluOperation();
      if (isQuicklyOperation) return;
      item.sessionTalk = !item.sessionTalk;
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: item.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: item.talentsRtilCodes,
        stationsRtilCodes: item.stationsRtilCodes,
        includeStations: false,
        timestamp: new Date().getTime()
      };
      const url = item.sessionTalk ? '/intercomPro/enablePushTalk' : '/intercomPro/disablePushTalk';
      this.axios.post(`/partyline-backend${url}`, params).then(res => {
        if (res.data.errorCode !== '0x0') {
          item.sessionTalk = !item.sessionTalk;
        } else {
          this.saveSessionTalkBehavior(item, item.sessionTalk);
        }
      });
    },
    contrlSessionTalk(item) {
      if (item.sessionTalk) {
        this.$message.warning(this.$t('intercom.cannotTalkToSession'));
        return;
      }
      if (this.State.intercomTalkToAllTalents) {
        this.$message.warning(this.$t('intercom.cannotTalkToSessionByTalkAll'));
        return;
      }
      const isQuicklyOperation = this.isQuickluOperation();
      if (isQuicklyOperation) return;
      item.pushToTalk = !item.pushToTalk;
      this.sendPushTalk(item, item.pushToTalk);
    },
    saveSessionTalkBehavior(item, val) {
      if (!this.partyInfo.joinCode) return;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'sessionTalk',
          subKey: item.intercomSessionId,
          mark: this.partyInfo.rtilCode,
          value: val,
          annotation: this.partyInfo.joinCode
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {});
    },
    controlSessionSpeaker(item, val) {
      if (!this.partyInfo.joinCode) return;
      item.sessionSpeaker = val == undefined ? !item.sessionSpeaker : val;
      const params = {
        userKkvs: [{
          module: 'setUserKkvs',
          key: 'sessionSpeaker',
          subKey: item.intercomSessionId,
          mark: this.partyInfo.rtilCode,
          value: item.sessionSpeaker,
          annotation: this.partyInfo.joinCode
        }],
        annotation: this.partyInfo.joinCode
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/setList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          var _this$State$bindStati;
          this.activeSpeakerInfo = item;
          // 如果是开启 sessionSpeaker 则需要判断当前是否有正在 pushtalk 如果有则需要播放声音
          const stationRtilCode = item.stationsRtilCodes[0];
          if (!stationRtilCode) return;
          const bindRtilCode = (_this$State$bindStati = this.State.bindStationInfo[stationRtilCode]) === null || _this$State$bindStati === void 0 ? void 0 : _this$State$bindStati.bindRtilCode;
          if (this.hasPushTalkingInfo[bindRtilCode]) {
            var _this$channels$bindRt;
            const audioTrack = (_this$channels$bindRt = this.channels[bindRtilCode]) === null || _this$channels$bindRt === void 0 ? void 0 : _this$channels$bindRt.audioTrack;
            if (item.sessionSpeaker) {
              this.speaker && (audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.play(audioTrack, '', {
                type: 'audio'
              }));
            } else {
              audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.stop();
            }
          }
        } else {
          item.sessionSpeaker = !item.sessionSpeaker;
        }
      }).catch(() => {
        item.sessionSpeaker = !item.sessionSpeaker;
      });
    },
    deleteSession(info, notNeedConfirm) {
      if (!info.intercomSessionId) return;
      if (info.status) {
        this.$message.warning(this.$t('intercom.cannotDeleteSession'));
        return;
      }
      if (notNeedConfirm) {
        this.axios.post('/partyline-backend/intercomPro/delSessionById', {
          sessionId: info.intercomSessionId,
          partyCode: this.partyInfo.joinCode
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            this.sessionList = this.sessionList.filter(item => item.intercomSessionId != info.intercomSessionId);
            if (this.selectSessionInfo.intercomSessionId === info.intercomSessionId) {
              this.selectSessionInfo = {};
              this.selectStationInfo = [];
            }
          }
        });
      } else {
        this.$confirm(this.$t('intercom.deleteSessionText'), this.$t('intercom.deleteSessionTitle'), {
          confirmButtonText: this.$t('kioskHost.yes'),
          cancelButtonText: this.$t('partylineGuest.cancel'),
          customClass: 'deleteSession'
        }).then(() => {
          this.axios.post('/partyline-backend/intercomPro/delSessionById', {
            sessionId: info.intercomSessionId,
            partyCode: this.partyInfo.joinCode
          }).then(res => {
            if (res.data.errorCode === '0x0') {
              this.sessionList = this.sessionList.filter(item => item.intercomSessionId != info.intercomSessionId);
              if (this.selectSessionInfo.intercomSessionId === info.intercomSessionId) {
                this.selectStationInfo = [];
                this.selectSessionInfo = {};
              }
            }
          });
        });
      }
    },
    searchTalent(key) {
      if (this.talentTimer) clearTimeout(this.talentTimer);
      this.talentTimer = setTimeout(() => {
        if (key) {
          this.talentList = this.allTalentList.filter(item => item.nickName.includes(key));
        } else {
          this.talentList = this.allTalentList;
        }
      }, 800);
    },
    searchStation(key) {
      if (this.stationTimer) clearTimeout(this.stationTimer);
      this.stationTimer = setTimeout(() => {
        if (key) {
          this.stationList = this.allStationList.filter(item => item.nickName.includes(key));
        } else {
          this.stationList = this.allStationList;
        }
      }, 800);
    },
    showAllData(key) {
      key === 'talent' ? this.talentList = this.allTalentList : this.stationList = this.allStationList;
    },
    deleteSource(item, type, isRTalent) {
      if (!this.partyInfo.joinCode) return;
      const currentSourceType = this.deviceType[item.rtilCode];
      if (currentSourceType === 'App') {
        this.deleteAppSource(item);
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        peerId: item.devicePeerId,
        rtilCode: item.rtilCode,
        type: 'device'
      };
      this.axios.delete('/partyline-backend/intercomPro/deviceRtilVoIP', {
        data: params
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
          if (type === 'talent' || isRTalent) {
            this.sessionList.forEach(sessionInfo => {
              sessionInfo.talentsRtilCodes = sessionInfo.talentsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              sessionInfo.sessionTalentsList = sessionInfo.sessionTalentsList.filter(info => info.rtilCode != item.rtilCode);
            });
            this.talentList = this.talentList.filter(info => info.rtilCode != item.rtilCode);
          } else {
            this.sessionList.forEach(sessionInfo => {
              sessionInfo.stationsRtilCodes = sessionInfo.stationsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              sessionInfo.sessionStationsList = sessionInfo.sessionStationsList.filter(info => info.rtilCode != item.rtilCode);
            });
            this.stationList = this.stationList.filter(info => info.rtilCode != item.rtilCode);
            this.State.stationList = this.State.stationList.filter(info => info.rtilCode != item.rtilCode);
            // 如果当前属于在选中状态，删除后需要重新更改选中数字
            const currentHasSelect = this.selectStationInfo.find(info => info.rtilCode === item.rtilCode);
            if (this.selectStationInfo.length && currentHasSelect) {
              const currentIndex = currentHasSelect.index;
              this.selectStationInfo.forEach(item => {
                if (item.index > currentIndex) item.index = item.index - 1;
              });
            }
          }
        }
      });
    },
    deleteAppSource(item) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        rtilCode: item.rtilCode
      };
      this.axios.post(`/partyline-backend/partyAction/removeParticipant?partyCode=${this.partyInfo.joinCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.sessionList.forEach(sessionInfo => {
            sessionInfo.talentsRtilCodes = sessionInfo.talentsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
            sessionInfo.sessionTalentsList = sessionInfo.sessionTalentsList.filter(info => info.rtilCode != item.rtilCode);
          });
          this.talentList = this.talentList.filter(info => info.rtilCode != item.rtilCode);
        }
      });
    },
    controlTalent(item) {
      // 为了创建新的 session
      if (!this.selectSessionInfo.intercomSessionId) {
        const hasAddNoSessionArray = this.noSessionSelectTalents.filter(info => info.rtilCode === item.rtilCode);
        if (hasAddNoSessionArray.length) {
          this.noSessionSelectTalents = this.noSessionSelectTalents.filter(info => info.rtilCode !== item.rtilCode);
        } else {
          this.noSessionSelectTalents.push({
            rtilCode: item.rtilCode,
            peerId: item.devicePeerId,
            sessionType: 'talent'
          });
        }
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        sessionTalentsList: [{
          rtilCode: item.rtilCode,
          peerId: item.devicePeerId,
          sessionType: 'talent'
        }]
      };
      const isAddOperation = !this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode);
      const url = isAddOperation ? '/partyline-backend/intercomPro/addSessionStationsTalents' : '/partyline-backend/intercomPro/delSessionStationsTalents';
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {
          // 根据当前的 session 状态决定是否也要调更新接口
          if (this.selectSessionInfo.status == 1) {
            this.updateTalentList(item);
          }
          // 如果当前在 talk to all talent 在添加设备时需要给设备发送消息，接收 host 声音
          if (this.State.intercomTalkToAllTalents) {
            this.setTalentReceiveHost(item);
          }
          if (this.selectSessionInfo.sessionTalk || this.selectSessionInfo.pushToTalk) {
            this.setDeviceReceiveHost(item);
          }
          const sessionId = this.selectSessionInfo.intercomSessionId;
          // 把 session list 里面的数据更改调
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              if (isAddOperation) {
                info.talentsRtilCodes.push(item.rtilCode);
                info.sessionTalentsList.push({
                  rtilCode: item.rtilCode,
                  peerId: item.devicePeerId
                });
              } else {
                info.talentsRtilCodes = info.talentsRtilCodes.filter(talent => talent != item.rtilCode);
                info.sessionTalentsList = info.sessionTalentsList.filter(talent => talent.rtilCode != item.rtilCode);
              }
            }
          });
        }
      });
    },
    updateTalentList(item) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: [item.rtilCode]
      };
      const isAddOperation = !this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode);
      if (!isAddOperation) params.cid = this.selectSessionInfo.cid;
      const url = isAddOperation ? '/partyline-backend/intercomPro/incrementalActive' : '/partyline-backend/intercomPro/incrementalInactive';
      this.axios.post(url, params).then(res => {});
    },
    setTalentReceiveHost(item) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: [item.rtilCode],
        timestamp: Date.now()
      };
      const isAddOperation = !this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode);
      const url = isAddOperation ? '/partyline-backend/intercomPro/enableIncrementalTalkALL' : '/partyline-backend/intercomPro/disableIncrementalTalkALL';
      this.axios.post(url, params).then(res => {});
    },
    setDeviceReceiveHost(item) {
      const sessionType = item.sessionType;
      const isTalent = sessionType === 'talent';
      const array = isTalent ? this.selectSessionInfo.talentsRtilCodes : this.selectSessionInfo.stationsRtilCodes;
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        talentsRtilCodes: isTalent ? [item.rtilCode] : [],
        stationsRtilCodes: !isTalent ? [item.rtilCode] : [],
        includeStations: this.selectSessionInfo.pushToTalk,
        timestamp: Date.now()
      };
      const url = !array.includes(item.rtilCode) ? '/partyline-backend/intercomPro/enableIncrementalPushTalk' : '/partyline-backend/intercomPro/disableIncrementalPushTalk';
      this.axios.post(url, params).then(async res => {});
    },
    controlStation(item) {
      if (!this.selectSessionInfo.intercomSessionId) {
        const hasAddNoSessionArray = this.noSessionSelectStations.filter(info => info.rtilCode === item.rtilCode);
        if (hasAddNoSessionArray.length) {
          this.noSessionSelectStations = this.noSessionSelectStations.filter(info => info.rtilCode !== item.rtilCode);
          const currentIndex = this.selectStationInfo.findIndex(info => info.rtilCode === item.rtilCode);
          this.selectStationInfo.forEach((item, index) => {
            if (index > currentIndex) {
              item.index += -1;
            }
          });
          this.selectStationInfo = this.selectStationInfo.filter(info => info.rtilCode != item.rtilCode);
        } else {
          this.noSessionSelectStations.push({
            rtilCode: item.rtilCode,
            peerId: item.devicePeerId,
            sessionType: 'stations'
          });
          this.selectStationInfo.push({
            rtilCode: item.rtilCode,
            index: this.selectStationInfo.length + 1
          });
        }
        return;
      } else {
        // 有选择 session 时执行的逻辑
        if (this.selectSessionInfo.sessionTalentsList.length == 1 && this.selectSessionInfo.talentsRtilCodes.includes(item.rtilCode) && this.selectSessionInfo.sessionStationsList.length == 0 || this.selectSessionInfo.sessionStationsList.length == 1 && this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode) && this.selectSessionInfo.sessionTalentsList.length == 0) {
          this.deleteSession(this.selectSessionInfo, 'notNeedConfirm');
          return;
        }
      }
      if (this.selectSessionInfo.status === 1 && this.selectSessionInfo.stationsRtilCodes.length && !this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        this.$message.warning(this.$t('intercom.cannotSwitchStation'));
        return;
      }
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        sessionStationsList: [{
          rtilCode: item.rtilCode,
          peerId: item.devicePeerId
        }]
      };
      if (!this.selectSessionInfo.stationsRtilCodes.length) {
        this.addStation(params, item);
        this.setDeviceReceiveHost(item);
      } else if (this.selectSessionInfo.stationsRtilCodes.length && this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        this.deleteStation(params, item);
        this.setDeviceReceiveHost(item);
      } else if (this.selectSessionInfo.stationsRtilCodes.length && !this.selectSessionInfo.stationsRtilCodes.includes(item.rtilCode)) {
        const deleteParams = JSON.parse(JSON.stringify(params));
        deleteParams.sessionStationsList[0].rtilCode = this.selectSessionInfo.stationsRtilCodes[0];
        deleteParams.sessionStationsList[0].peerId = this.selectSessionInfo.sessionStationsList[0].devicePeerId || this.selectSessionInfo.sessionStationsList[0].peerId;
        console.log(111111, JSON.stringify(params));
        this.deleteStation(deleteParams, {
          rtilCode: this.selectSessionInfo.stationsRtilCodes[0]
        });
        this.addStation(params, item);
      }
    },
    addStation(params, item) {
      this.axios.post('/partyline-backend/intercomPro/addSessionStationsTalents', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const sessionId = this.selectSessionInfo.intercomSessionId;
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              info.stationsRtilCodes = [item.rtilCode];
              info.sessionStationsList = [item];
            }
          });
          // 如果当前处于 active 活跃状态需要再掉接口更新
          if (this.selectSessionInfo.status === 1) this.updateStationList(item, 'add');
        }
      });
    },
    deleteStation(params, item) {
      this.axios.post('/partyline-backend/intercomPro/delSessionStationsTalents', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const sessionId = this.selectSessionInfo.intercomSessionId;
          this.sessionList.forEach(info => {
            if (info.intercomSessionId == sessionId) {
              info.stationsRtilCodes = info.stationsRtilCodes.filter(rtilCode => rtilCode != item.rtilCode);
              info.sessionStationsList = info.sessionStationsList.filter(obj => obj.rtilCode != item.rtilCode);
            }
          });
          // 如果当前处于 active 活跃状态需要再掉接口更新
          if (this.selectSessionInfo.status === 1) this.updateStationList(item, 'delete');
        }
      });
    },
    updateStationList(item, key) {
      const params = {
        partyCode: this.partyInfo.joinCode,
        intercomSessionId: this.selectSessionInfo.intercomSessionId,
        rtilCode: this.partyInfo.rtilCode,
        stationsRtilCodes: [item.rtilCode]
      };
      if (key === 'delete') params.cid = this.selectSessionInfo.cid;
      const url = key === 'add' ? '/partyline-backend/intercomPro/incrementalActive' : '/partyline-backend/intercomPro/incrementalInactive';
      this.axios.post(url, params).then(res => {});
    },
    dealNameItemCalback(item) {
      const isRTalent = item.sessionType === 'talent' && item.deviceType === 'R';
      this.deleteSource(item, item.deviceType === 'T' ? 'talent' : 'station', isRTalent);
      if (item.deviceType === 'R' && !isRTalent) this.unbiandStation(item);
    },
    unbiandStation(item) {
      const params = {
        email: item.email,
        rtilCode: item.rtilCode,
        partyCode: this.partyInfo.joinCode,
        peerId: item.devicePeerId,
        startRtilCode: this.partyInfo.rtilCode
      };
      this.axios.post('/partyline-backend/intercomPro/unbindStation', params).then(res => {});
    },
    returnTalentsName(item) {
      return item.sessionTalentsList.length ? item.sessionTalentsList.map(info => {
        return this.nickNameMap[info.rtilCode] || info.peerId;
      }).join(',') : '';
    },
    returnStationName(item) {
      return this.nickNameMap[item.rtilCode] ? this.nickNameMap[item.rtilCode] : item.deviceType === 'R' ? item.deviceName + '_voip' : '';
    },
    returnTalentSelect(item) {
      let flag = false;
      if (!this.selectSessionInfo.intercomSessionId) {
        this.noSessionSelectTalents.forEach(info => {
          if (info.rtilCode === item.rtilCode) flag = true;
        });
      } else {
        this.sessionList.forEach(sessionInfo => {
          if (sessionInfo.intercomSessionId === this.selectSessionInfo.intercomSessionId) {
            sessionInfo.sessionTalentsList.forEach(info => {
              if (info.rtilCode === item.rtilCode) flag = true;
            });
          }
        });
      }
      return flag;
    },
    returnSelectIndex(item) {
      let index = 1;
      this.selectStationInfo.findIndex(info => {
        if (info.rtilCode === item.rtilCode) {
          index = info.index;
        }
      });
      return index;
    },
    returnStationSelect(item, key) {
      let flag = false;
      if (key === 'session') {
        this.sessionList.forEach(sessionInfo => {
          if (sessionInfo.intercomSessionId === this.selectSessionInfo.intercomSessionId) {
            sessionInfo.sessionStationsList.forEach(info => {
              if (info.rtilCode === item.rtilCode) flag = true;
            });
          }
        });
      } else {
        this.noSessionSelectStations.forEach(info => {
          if (info.rtilCode === item.rtilCode) flag = true;
        });
      }
      return flag;
    },
    returnStationStatus(item, key) {
      if (key === 'web') {
        var _this$State$bindStati2;
        const bindRtilCode = (_this$State$bindStati2 = this.State.bindStationInfo[item.rtilCode]) === null || _this$State$bindStati2 === void 0 ? void 0 : _this$State$bindStati2.bindRtilCode;
        return this.allRtilCode.find(info => info.rtilCode == bindRtilCode);
      } else {
        return item.online;
      }
    },
    returnUserID(item) {
      var _this$State$bindStati3;
      if (!item.email) return '';
      const bindRtilCode = (_this$State$bindStati3 = this.State.bindStationInfo[item.rtilCode]) === null || _this$State$bindStati3 === void 0 ? void 0 : _this$State$bindStati3.bindRtilCode;
      const isHasJoin = this.allRtilCode.find(info => info.rtilCode == bindRtilCode);
      return isHasJoin ? this.nickNameMap[bindRtilCode] ? this.nickNameMap[bindRtilCode] : bindRtilCode : '-- --';
    },
    stationReJoin(item) {
      const params = [{
        partyCode: this.partyInfo.joinCode,
        peerId: item.devicePeerId,
        nickName: item.nickName,
        type: 'R'
      }];
      this.axios.post('/partyline-backend/intercomPro/batch/addDeviceRtilVoIP', params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '82201412') {
          const result = res.data.errorResult;
          const htmlString = result.map(item => this.$t('commonFunction.addDeviceFailed', {
            deviceName: item.nickName,
            reason: item.errorMessage
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        } else if (res.data.errorCode === '82201001' || res.data.errorCode === '81000004') {
          this.$message.error(this.$t('common.closeOperationFailed'));
        } else if (res.data.errorCode === '82201409') {
          const result = res.data.errorResult;
          const htmlString = result.map(item => this.$t('common.repeatVoipJoined', {
            deviceId: item.receiverId,
            nickName: item.nickName
          })).join('<br>');
          this.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: htmlString
          });
        }
      }).catch(e => {
        console.log(e);
      });
    },
    clearNoSessionInfo() {
      this.selectStationInfo = [];
      this.noSessionSelectTalents = [];
      this.noSessionSelectStations = [];
    },
    leave(id) {
      this.allRtilCode = this.allRtilCode.filter(item => item.rtilCode != id);
      this.talentList = this.talentList.filter(info => info.rtilCode != id);
      this.stationList.forEach(item => {
        if (item.rtilCode == id) {
          item.online = false;
        }
      });
    }
  },
  beforeRouterLeave() {
    var _this$rtc;
    (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc.leave();
    window.removeEventListener(this.listenEvent);
  }
};